import { PTableRow } from "@porsche-design-system/components-react"
import { Flex } from "src/components/Flex"
import { Skeleton } from "src/components/skeleton"
import { TableCellFixed } from "src/components/tableCellFixed/TableCellFixed"
import { VehicleHistoryListTableHead } from "./VehicleHistoryListTableHead"
import { vehicleHistoryListColumns } from "./vehicleHistoryListColumns.const"

export const VehicleHistoryListSkeleton = ({ rows = 50 }: { rows?: number }) => (
	<Skeleton.Table
		caption="Vehicle History List"
		layout="fixed"
		tableHead={<VehicleHistoryListTableHead />}
		renderCustomRow={(index) => (
			<PTableRow key={index}>
				<TableCellFixed $width={vehicleHistoryListColumns.dateTime}>
					<Skeleton.Text $width="130px" />
				</TableCellFixed>
				<TableCellFixed $width={vehicleHistoryListColumns.event}>
					<Flex $gap="xs">
						<Skeleton.Text $width="24px" />
						<Skeleton.Text $width={`${vehicleHistoryListColumns.event - 30}px`} />
					</Flex>
				</TableCellFixed>
				<TableCellFixed $width={vehicleHistoryListColumns.details}>
					<Skeleton.Text $width={`${vehicleHistoryListColumns.details / 2}px`} />
				</TableCellFixed>
				<TableCellFixed $width={vehicleHistoryListColumns.trigger}>
					<Skeleton.Text $width="60px" />
				</TableCellFixed>
			</PTableRow>
		)}
		rows={rows}
	/>
)
